import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { ContentCard } from '@/shared/ui';

interface Shortcut {
  readonly label: string;
  readonly to: string;
  readonly description: string;
}

/** 자주 가는 화면 — 준비 중 메뉴(제작 발주 자료)는 생기면 더한다. */
const SHORTCUTS: readonly Shortcut[] = [
  { label: '상품 등록', to: '/products/editor', description: '새 상품을 등록합니다.' },
  { label: '견적 요청', to: '/quotes', description: '상담을 처리하고 견적서를 발행합니다.' },
  { label: '주문 목록', to: '/orders', description: '제작 착수·발송을 처리합니다.' },
  {
    label: '알림 설정',
    to: '/notifications/settings',
    description: '담당자 주소와 발송 유형을 관리합니다.',
  },
];

export const DashboardShortcutsWidget = (): ReactElement => (
  <ContentCard title="바로가기">
    <ul className="grid grid-cols-2 gap-2">
      {SHORTCUTS.map((shortcut) => (
        <li key={shortcut.to}>
          <Link
            to={shortcut.to}
            className="flex h-full flex-col gap-0.5 rounded-xl border border-foreground/10 px-4 py-3 transition-colors hover:bg-foreground/[0.03]"
          >
            <span className="text-sm font-semibold">{shortcut.label}</span>
            <span className="text-xs text-muted-foreground">{shortcut.description}</span>
          </Link>
        </li>
      ))}
    </ul>
  </ContentCard>
);
